(function () {
  var BUY_NOW_PATHS = ['/products/founders-membership'];

  function isBuyNowPage() {
    return BUY_NOW_PATHS.some(function (path) {
      return window.location.pathname.indexOf(path) === 0;
    });
  }

  if (!isBuyNowPage()) return;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var submitButton = form.querySelector('button[type="submit"]');
    var originalText = submitButton ? submitButton.innerText : null;

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerText = 'Processing...';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'We could not process your membership. Please try again.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Become a Member error:', error);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerText = originalText || 'Become a Member';
        }
        alert(error.message || 'Something went wrong. Please try again.');
      });
  }, true);
})();